import { FC } from 'react'

import { RadioGroup } from 'ui/components'
import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { MainText, SecondText } from '../../style'
import { ReviewTheCashActivityProps } from './ReviewTheCashActivityProps'

export const ReviewTheCashActivity: FC<ReviewTheCashActivityProps> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <MainText>Deposits apparently structured to avoid Currency Transaction Report (CTR) requirements.</MainText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <SecondText>
          Review the cash activity amounts for repeated deposits/withdrawals at the $10,000.00 threshold.
        </SecondText>
      </Col>
      <Col>
        <Field
          name="reviewTheCashActivityRedFlag"
          input={RadioGroup}
          inputProps={{
            data: [
              {
                label: 'Yes',
                value: 'yes'
              },
              {
                label: 'No',
                value: 'no'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTheCashActivityStructuringDeposits"
          label="Has the business been structuring?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'No Transactions of This Type',
                value: 'no_transactions'
              },
              {
                label: 'All Transactions Ok',
                value: 'all_transactions_ok'
              },
              {
                label: 'Transactions addressed with communication to customer during review',
                value: 'transactions_addressed'
              },
              {
                label: 'Other – See comments',
                value: 'other'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewTheCashActivityComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
